export const SESSION_EXPIRED_EVENT = new Event('SESSION_EXPIRED');
export default async function customFetch(url, config) {
    const response = await fetch(url, config);
    if (response.status === 401) {
        document.dispatchEvent(SESSION_EXPIRED_EVENT);
    }
    return response;
}
//# sourceMappingURL=customFetch.js.map